import { render, staticRenderFns } from "./LeadNewLeadTakeControl.vue?vue&type=template&id=1613be4e&"
import script from "./LeadNewLeadTakeControl.vue?vue&type=script&lang=js&"
export * from "./LeadNewLeadTakeControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports